@if (hasDeleteButton || hasEditButton) {
  <div class="row">
    @if (hasEditButton) {
      <button
        class="button-for-icons action-edit-icon"
        [disabled]="editButtonDisabled"
        (click)="clickEdit(data)"
      >
        <ion-icon
          [src]="editButtonDisabled ? IMAGE.EDIT : IMAGE.EDIT_BLUE"
          class="action-edit-icon"
        ></ion-icon>
      </button>
    }
    @if (hasDeleteButton) {
      <button
        class="button-for-icons"
        [disabled]="deleteButtonDisabled"
        (click)="clickDelete(data)"
      >
        <ion-icon
          [src]="deleteButtonDisabled ? IMAGE.DELETE_INACTIVE : IMAGE.DELETE"
          class="action-delete-icon"
          [ngClass]="{ active: !deleteButtonDisabled }"
        ></ion-icon>
      </button>
    }
  </div>
}
